import { LinearProgress, LinearProgressProps, Stack, Typography } from '@o2/ui';
import { FC, ReactNode } from 'react';

export interface ProgressBarElmIds {
  title?: string;
  description?: string;
  bar?: string;
  legendStart?: string;
  legendEnd?: string;
}

export interface ProgressBarProps extends Omit<LinearProgressProps, 'title'> {
  /**
   * title
   */
  title: ReactNode;

  /**
   * description
   */
  description?: ReactNode;

  /**
   * Progress bar start legend
   */
  legendStart?: ReactNode;

  /**
   * Progress bar end legend
   */
  legendEnd?: ReactNode;

  /**
   * Element ids
   */
  elmIds?: ProgressBarElmIds;
}

const ProgressBar: FC<ProgressBarProps> = ({
  title,
  description,
  legendStart,
  legendEnd,
  elmIds,
  variant = 'determinate',
  value = 0,
  ...props
}) => {
  return (
    <Stack direction="column" gap={1}>
      <Stack direction="row" justifyContent="space-between" alignItems="end" gap={3}>
        {title && (
          <Typography data-elm={elmIds ? elmIds.title : undefined} color="textSecondary" variant="subtitle2">
            {title}
          </Typography>
        )}
        {description && (
          <Typography data-elm={elmIds ? elmIds.description : undefined} color="textSecondary" variant="body2">
            {description}
          </Typography>
        )}
      </Stack>
      <LinearProgress variant={variant} value={value} {...props} />
      <Stack
        direction="row"
        justifyContent={legendStart && legendEnd ? 'space-between' : legendEnd ? 'end' : 'start'}
        alignItems="start"
        gap={3}
      >
        {legendStart && (
          <Typography data-elm={elmIds ? elmIds.legendStart : undefined} color="textSecondary" variant="body2">
            {legendStart}
          </Typography>
        )}
        {legendEnd && (
          <Typography data-elm={elmIds ? elmIds.legendEnd : undefined} color="textSecondary" variant="body2">
            {legendEnd}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default ProgressBar;
